import { render, staticRenderFns } from "./RestaurantsLeisures.vue?vue&type=template&id=ae7e5640&scoped=true&"
import script from "./RestaurantsLeisures.vue?vue&type=script&lang=js&"
export * from "./RestaurantsLeisures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7e5640",
  null
  
)

export default component.exports